import { logout } from '@/shared/auth/actions';
import { getTokenInfo, setToken, setUserId } from '@/shared/auth/auth';

export const TERMINAL_ALL_SCHEDULES = -1;
export const LIMITED_TOKEN_ALLOWED_PATHS = ['/timeclock'];
export const LS_SCHEDULE_ID_KEY = 'wiw-terminal-schedule-id';

export function lock(userId: number, token: string, scheduleId: number) {
  // Expire cookies in 10 years so bookmarked terminals remain locked
  setToken(token, { expires: 3650 });
  setUserId(`${userId}`, { expires: 3650 });

  window.localStorage.setItem(LS_SCHEDULE_ID_KEY, JSON.stringify(scheduleId));
}

export function unlock() {
  window.localStorage.removeItem(LS_SCHEDULE_ID_KEY);
  logout();
}

export function isLocked(): boolean {
  return !!getTokenInfo().isLimited();
}

export function getLockedScheduleId(): number | null {
  const value = window.localStorage.getItem(LS_SCHEDULE_ID_KEY);
  return value && JSON.parse(value);
}

export function shouldLimitedTokenLogout(path: string): boolean {
  return isLocked() && !LIMITED_TOKEN_ALLOWED_PATHS.includes(path);
}
